// test2604
(2604 && 0);
